// assets
import { IconExchange } from '@tabler/icons';
import { createChildGroupMenuItem, createChildMenuItem, createMenuItem } from 'utils/menu';

// ==============================|| PROGRAM CHANGE MENU ITEMS ||============================== //

const programChangeItems = [
  createMenuItem('program-change-requests', 'program.change.requests.read', 'Pengajuan Perubahan Program', '/program-change', IconExchange, false),
  createMenuItem('program-change-approved', 'program.change.approved.read', 'Perubahan yang Disetujui', '/program-change/approved', IconExchange, false)
];

const children = [
  {
    id: 'program-change-menu',
    perm: 'program.change.read',
    title: 'Perubahan Program',
    type: 'collapse',
    icon: IconExchange,
    children: createChildMenuItem(programChangeItems)
  }
];

const programChange = {
  id: 'program-change',
  title: '',
  type: 'group',
  children: createChildGroupMenuItem(children)
};

export default programChange;

